import React from 'react';

export interface AllergensListProps {
    allergens: string[];
    onClick: any
}

function AllergensList(props: AllergensListProps) {
    return (
        <div onClick={() => props.onClick()} className='allergens-container flex-start-center'>
            {props.allergens.map(_ => <div className='allergens-item'>{_}</div>)}
        </div>
    );
}

export default AllergensList;